var _circle, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44,
    fill: "#F2F2F2",
    stroke: "#CCCCCC",
    strokeWidth: 2
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 90,
    height: 90
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 45,
    r: 44,
    fill: "#F2F2F2",
    stroke: "#CCCCCC",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45.2395,
    cy: 33.3057,
    r: 14.3057,
    fill: "#CCCCCC",
    stroke: "#CCCCCC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02708 93.1525C4.75434 95.3792 6.57915 97.229 8.82242 97.229H81.6566C83.8998 97.229 85.7246 95.3792 85.4519 93.1525C82.9987 73.1245 65.9304 57.6143 45.2395 57.6143C24.5486 57.6143 7.48028 73.1245 5.02708 93.1525Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02708 93.1525C4.75434 95.3792 6.57915 97.229 8.82242 97.229H81.6566C83.8998 97.229 85.7246 95.3792 85.4519 93.1525C82.9987 73.1245 65.9304 57.6143 45.2395 57.6143C24.5486 57.6143 7.48028 73.1245 5.02708 93.1525Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.4519 93.1525L83.4667 93.3957L85.4519 93.1525ZM8.82242 99.229H81.6566V95.229H8.82242V99.229ZM45.2395 59.6143C64.9075 59.6143 81.1349 74.3584 83.4667 93.3957L87.4371 92.9094C84.8625 71.8906 66.9533 55.6143 45.2395 55.6143V59.6143ZM7.01224 93.3957C9.34409 74.3584 25.5715 59.6143 45.2395 59.6143V55.6143C23.5257 55.6143 5.61646 71.8906 3.04191 92.9094L7.01224 93.3957ZM81.6566 99.229C84.9602 99.229 87.8724 96.4635 87.4371 92.9094L83.4667 93.3957C83.5769 94.2948 82.8395 95.229 81.6566 95.229V99.229ZM8.82242 95.229C7.63951 95.229 6.90211 94.2948 7.01224 93.3957L3.04191 92.9094C2.60657 96.4635 5.5188 99.229 8.82242 99.229V95.229Z",
    fill: "#CCCCCC",
    mask: "url(#path-4-inside-1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAvatar);
export default __webpack_public_path__ + "static/media/user-avatar.e4dd5ca20ff8e689a959ff1334708d0c.svg";
export { ForwardRef as ReactComponent };